import { render, staticRenderFns } from "./ServiceImage.vue?vue&type=template&id=0825e752&scoped=true&"
import script from "./ServiceImage.vue?vue&type=script&lang=js&"
export * from "./ServiceImage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceImage.vue?vue&type=style&index=0&id=0825e752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825e752",
  null
  
)

export default component.exports